import React from "react";

export default function Compliance() {
  const complianceItems = [
    {
      title: "ERISA Alignment",
      description:
        "Operates as non-ERISA platform unless integrated with FSAs/ICHRAs. Wrap plan documents provided.",
    },
    {
      title: "HIPAA Safe",
      description:
        "No PHI is stored on-chain. All sensitive data remains off-chain with vendors.",
    },
    {
      title: "IRS / ACA Ready",
      description:
        "Contributions treated as deductible expenses. Supports QSEHRAs, ICHRAs, and 1095/W-2 compliance.",
    },
    {
      title: "State & Federal Mandates",
      description:
        "Compliant across jurisdictions. Legal opinion letters available.",
    },
    {
      title: "AI Oversight",
      description:
        "LLMs reference plan docs only. All chat sessions are logged and audit-ready.",
    },
  ];

  return (
    <section className="bg-white py-20 px-6" id="compliance">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Compliant by Design
        </h2>
        <p className="text-gray-600 text-lg max-w-3xl mx-auto">
          Built with embedded compliance logic and auditability for ERISA, HIPAA, ACA, and AI-related standards — no legal blind spots.
        </p>
        <div className="grid md:grid-cols-2 gap-8 text-left mt-12">
          {complianceItems.map((item, idx) => (
            <div
              key={idx}
              className="p-6 border rounded-lg shadow-sm bg-gray-50"
            >
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 